import InvoiceDetailsLayout from "./invoiceDetailsLayout";

const InvoiceDetailsPage = () => {
  return <InvoiceDetailsLayout />;
};

export default InvoiceDetailsPage;